module.exports = __webpack_public_path__ + "img/article-icon.17934b56.png";